export const useLoadingStore = defineStore('loading', () => {
  const _loadingCounter = ref(0);
  const isLoading = computed(() => _loadingCounter.value > 0);

  const startLoad = () => _loadingCounter.value++;

  const endLoad = () => _loadingCounter.value--;

  return {
    isLoading,
    startLoad,
    endLoad,
  };
});
